<section class="main-container bounceInUp animated">
    <div class="container-fluid px-2">
        <div class="row">
            <div class="col-lg-2 col-md-3 order-lg-1 order-md-1 mt-4 mt-md-0">
                <app-side-nav-categories [activeSlug]="slug"></app-side-nav-categories>
            </div>
            <div class="col-lg-10 col-md-9 order-lg-2 order-md-2">
                <div class="page-heading">
                    <div class="page-title">
                        <h2>{{ title }}</h2>
                    </div>
                </div>
                <div class="pro-coloumn" *ngIf="loading; else listing_offers">
                    <p style="text-align: center">{{ 'common.loading' | translate }} ...</p>
                </div>
                <ng-template #listing_offers>
                    <div class="pro-coloumn">
                        <ng-template #products_not_found>
                            <div class="empty-state">
                                <div class="empty-icon">
                                    <i class="fa fa-box-open"></i>
                                </div>
                                <h3 class="empty-title">{{ 'products.no_products' | translate }}</h3>
                                <p class="empty-subtitle">{{ 'products.no_results_subtitle' | translate }}</p>
                            </div>
                            <div class="recommended-section" *ngIf="recommendedOffers.length > 0">
                                <h4 class="recommended-title">{{ 'products.you_might_like' | translate }}</h4>
                                <div class="product-grid">
                                    <div class="product-card" *ngFor="let offer of recommendedOffers">
                                        <a [routerLink]="['/products', offer.product.slug == null ? offer.product.name : offer.product.slug, offer.id]" class="card-image-wrapper">
                                            <img class="card-image" [defaultImage]="'/assets/images/default.jpg'" [lazyLoad]="getImageSrc(offer)" [alt]="offer.product.name" />
                                            <div class="discount-badge" *ngIf="isInPromotion(offer)">-{{ offer.percentDiscount }}%</div>
                                            <div class="stock-badge" *ngIf="offer.qty > 0 && !offer.availableDate; else outOfStock">{{ 'product.in_stock' | translate }}</div>
                                            <ng-template #outOfStock>
                                                <div class="stock-badge out-of-stock">{{ 'product.out_of_stock' | translate }}</div>
                                            </ng-template>
                                        </a>
                                        <div class="card-content">
                                            <a [routerLink]="['/products', offer.product.slug == null ? offer.product.name : offer.product.slug, offer.id]" class="product-name">
                                                {{ lang === 'fr' ? offer.product.productNameFr : offer.product.productName }}
                                            </a>
                                            <p class="product-desc">{{ stripHtml(offer.description) }}</p>
                                            <div class="product-price">
                                                <span class="current-price">{{ getOfferPrice(offer) | number }} {{ offer.currency | uppercase }}</span>
                                                <span class="old-price" *ngIf="isInPromotion(offer)">{{ offer.price | number }} {{ offer.currency | uppercase }}</span>
                                                <span class="unit-price"> / {{ lang === 'fr' ? offer.measurementunit.descriptionFr : offer.measurementunit.description }}</span>
                                            </div>
<div class="product-actions">
                                                <button *ngIf="!isOfferInCart(offer) && offer.qty > 0 && !offer.availableDate" class="btn-add" (click)="$event.stopPropagation(); addToCart(offer)">
                                                    <i class="fa fa-shopping-cart"></i>
                                                    <span>{{ 'common.add_to_cart' | translate }}</span>
                                                </button>
                                                <button class="btn-like" (click)="$event.stopPropagation(); addToWishlist(offer.id)">
                                                    <i class="fa fa-heart"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <article *ngIf="offers.length > 0; else products_not_found">
                            <div class="product-grid">
                                <div class="product-card" *ngFor="let offer of offers | paginate: config">
                                    <a
                                        [routerLink]="['/products', offer.product.slug == null ? offer.product.name : offer.product.slug, offer.id]"
                                        class="card-image-wrapper">
                                        <img
                                            class="card-image"
                                            [defaultImage]="'/assets/images/default.jpg'"
                                            [lazyLoad]="getImageSrc(offer)"
                                            [alt]="offer.product.name" />
                                        <div class="discount-badge" *ngIf="isInPromotion(offer)">
                                            -{{ offer.percentDiscount }}%
                                        </div>
                                        <div class="stock-badge" *ngIf="offer.qty > 0 && !offer.availableDate; else outOfStock">
                                            {{ 'product.in_stock' | translate }}
                                        </div>
                                        <ng-template #outOfStock>
                                            <div class="stock-badge out-of-stock">
                                                {{ 'product.out_of_stock' | translate }}
                                            </div>
                                        </ng-template>
                                    </a>
                                    <div class="card-content">
                                        <a
                                            [routerLink]="['/products', offer.product.slug == null ? offer.product.name : offer.product.slug, offer.id]"
                                            class="product-name">
                                            {{ lang === 'fr' ? offer.product.productNameFr : offer.product.productName }}
                                        </a>
                                        <p class="product-desc">{{ stripHtml(offer.description) }}</p>
                                        <div class="product-price">
                                            <span class="current-price">
                                                {{ getOfferPrice(offer) | number }} {{ offer.currency | uppercase }}
                                            </span>
                                            <span class="old-price" *ngIf="isInPromotion(offer)">
                                                {{ offer.price | number }} {{ offer.currency | uppercase }}
                                            </span>
                                            <span class="unit-price">
                                                / {{ lang === 'fr' ? offer.measurementunit.descriptionFr : offer.measurementunit.description }}
                                            </span>
                                        </div>
                                        <div class="product-actions">
                                            <button
                                                *ngIf="!isOfferInCart(offer)" [disabled]="offer.availableDate"
                                                class="btn-add"
                                                (click)="$event.stopPropagation(); addToCart(offer)">
                                                <i class="fa fa-shopping-cart"></i>
                                                <span>{{ 'common.add_to_cart' | translate }}</span>
                                            </button>
                                            <button
                                                class="btn-like"
                                                (click)="$event.stopPropagation(); addToWishlist(offer.id)">
                                                <i class="fa fa-heart"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="toolbar" *ngIf="config.totalOfPage > 1">
                                <div class="pager">
                                    <pagination-controls
                                        class="pages"
                                        maxSize="5"
                                        [previousLabel]="'common.previous' | translate"
                                        [nextLabel]="'common.next' | translate"
                                        autoHide="true"
                                        id="listing"
                                        (pageChange)="pageChange($event)">
                                    </pagination-controls>
                                </div>
                            </div>
                        </article>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</section>
